






































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import requestService from "@/service/requestService";
import { Action, Getter } from "vuex-class";
import { ElButton } from 'element-ui/types/button';
import QuickMitsumoriListComponent from "@/components/QuickMitsumoriListComponent.vue";

@Component({
  components: {
    Header,
    QuickMitsumoriListComponent
  }
})
export default class UserMenu extends Vue {
  reqService: requestService;
  message: string = "";
  showDialogQuickMitsumori: boolean = false;
  torokubangoDialogSelected: any = ""; // Dialog上で選択されている見積もりを区別するために使用している
  currentRowSelectQuick: any;

  constructor() {
    super();
  }

  gotoReservationNumber() {
    this.$router.push("/user/reservationnumber");
  }

  gotoQuickMisumori() {
    this.$router.push({ name: "quickmitsumorilist" });
  }

  showDialogQuickMitsumoriOpened() {
    this.showDialogQuickMitsumori = true;
  }

  onCloseSearchQuickMitsumori() {
    this.showDialogQuickMitsumori = false;
  }

  onSearchQuickMitsumoriClose() {
    this.showDialogQuickMitsumori = false;
    if (this.torokubangoDialogSelected && this.torokubangoDialogSelected != '') {
      this.$router.push({ name: "user-quickinfo", params: { code: this.torokubangoDialogSelected } });
    }
  }

  onShowDialogQuickMisumoriSearch() {
    this.showDialogQuickMitsumori = true;
  }

  onSelectCurrentRowQuickMitsumori(e: any) {
    console.log("userMenu.onSelectCurrentRowQuickMitsumori e => ", e);
    this.currentRowSelectQuick = {...e};
    this.torokubangoDialogSelected = (e && e.sknQuickMitsumoriId) ? e.sknQuickMitsumoriId : "";
  }

  get isConfirmQuickSearchDisabled() {
    let isOK = true;

    if (!this.torokubangoDialogSelected) {
      isOK = false;
    }

    return !isOK;
  }

}
